<style>
#tasksRegisterModal .v--modal-box.v--modal {
  min-height: 460px !important;
  min-width: 750px !important;
}
#tasksRegisterModal .modal__content {
  overflow-y: hidden !important;
}
</style>

<template>
  <Modal
    modalName="tasksRegisterModal"
    title="REJESTR ZADAŃ"
    :buttons="[]"
    :register="register"
  >
    <TasksTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import TasksTable from "../../table/TasksTable";

export default {
  components: {
    Modal,
    TasksTable
  },
  data: () => ({
    register: true
  }),
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/tasks/modals/TasksRegister.vue